import propTypes from 'prop-types';
import { useTheme } from 'styled-components';

const SvgKeepOpenDoorIcon = ({ size, color, ...props }) => {
  const theme = useTheme();

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 216 332"
      fill={theme.colors[color] || color}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M94.2907 16.2247C94.2907 6.41381 102.932 -1.15166 112.657 0.144991L201.878 12.0412C209.937 13.1157 215.956 19.9904 215.956 28.1209V303.879C215.956 312.01 209.937 318.884 201.878 319.959L112.657 331.855C102.932 333.152 94.2907 325.586 94.2907 315.775V16.2247Z"
        fill="inherit"
      />
      <path
        d="M122.679 174.111C122.679 183.07 118.14 190.333 112.541 190.333C106.941 190.333 102.402 183.07 102.402 174.111C102.402 165.152 106.941 157.889 112.541 157.889C118.14 157.889 122.679 165.152 122.679 174.111Z"
        fill="white"
      />
      <path
        d="M33.458 30.1403C33.458 21.1811 40.7209 13.9182 49.68 13.9182H199.734C208.693 13.9182 215.956 21.1811 215.956 30.1403V301.86C215.956 310.819 208.693 318.082 199.734 318.082H49.68C40.7209 318.082 33.458 310.819 33.458 301.86V226.833H49.68V293.749C49.68 298.228 53.3115 301.86 57.7911 301.86H191.623C196.103 301.86 199.734 298.228 199.734 293.749V46.3623C199.734 37.4032 192.471 30.1403 183.512 30.1403H57.7911C53.3115 30.1403 49.68 33.7717 49.68 38.2513V88.9452H33.458V30.1403Z"
        fill="inherit"
      />
      <path
        d="M70.9715 140.315H65.9021V130.273C65.9021 116.415 54.5467 105.167 40.5551 105.167C26.5636 105.167 15.2082 116.415 15.2082 130.273V140.315H10.1388C4.56245 140.315 0 144.834 0 150.357V200.568C0 206.092 4.56245 210.611 10.1388 210.611H70.9715C76.5478 210.611 81.1103 206.092 81.1103 200.568V150.357C81.1103 144.834 76.5478 140.315 70.9715 140.315ZM40.5551 185.505C34.9788 185.505 30.4164 180.986 30.4164 175.463C30.4164 169.94 34.9788 165.421 40.5551 165.421C46.1315 165.421 50.6939 169.94 50.6939 175.463C50.6939 180.986 46.1315 185.505 40.5551 185.505ZM56.2703 140.315H24.84V130.273C24.84 121.687 31.8865 114.707 40.5551 114.707C49.2238 114.707 56.2703 121.687 56.2703 130.273V140.315Z"
        fill="inherit"
      />
    </svg>
  );
};

export default SvgKeepOpenDoorIcon;

SvgKeepOpenDoorIcon.propTypes = {
  size: propTypes.string,
  color: propTypes.string,
};

SvgKeepOpenDoorIcon.defaultProps = {
  size: '16px',
  color: 'highBlack',
};
